export enum ClickspotType {
  PIN = 'pin',
  RECTANGLE = 'rectangle'
}